export default {
    'welcome': '欢迎',
    'home': '主页',
    'dashboard.title': '仪表盘',
    'dashboard.analysis': '分析页',
    'dashboard.monitor': '监控页',
    'dashboard.workplace': '工作台',
    'form.title': '表单页',
    'form.basic-form': '基础表单',
    'form.step-form.title': '分步表单',
    'form.step-form.info': '分步表单（填写转账信息）',
    'form.step-form.confirm': '分步表单（确认转账信息）',
    'form.step-form.result': '分步表单（完成）',
    'form.advanced-form': '高级表单',
    'list.title': '列表页',
    'list.table-list': '查询表格',
    'list.basic-list': '标准列表',
    'list.card-list': '卡片列表',
    'list.search-list.title': '搜索列表',
    'list.search-list.articles': '搜索列表（文章）',
    'list.search-list.projects': '搜索列表（项目）',
    'list.search-list.applications': '搜索列表（应用）',
    'profile.title': '详情页',
    'profile.basic': '基础详情页',
    'profile.advanced': '高级详情页',
    'result.title': '结果页',
    'result.success': '成功页',
    'result.fail': '失败页',
    'exception.title': '异常页',
    'exception.not-permission': '403',
    'exception.not-find': '404',
    'exception.server-error': '500',
    'exception.trigger': '触发错误',
    'account.title': '个人页',
    'account.center': '个人中心',
    'account.settings': '个人设置',
    'account.trigger': '触发报错',
    'account.logout': '退出登录',
    'dynamicForm': '动态表单',
    'logicflow': '流程图',
    'makeChart': '图表设计器(拖拽)',
    'dragChart': '图表设计器(缩放)',
    'tenant.list': '租户列表',
    'tenant.manage': '租户管理',
    'tenant.account': '租户账号管理',
    'dict.dictType': '字典管理',
    'dict.dictData': '字典数据管理',
    "menu.manage": "菜单管理",
    "service.manage": "服务管理",
    "role.manage": "角色管理",
    "permission.manage": "权限管理",
}
